import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { CompanyStockIndexesDto, UpsertCompanyStockIndexesRequest } from '../../models/api/companyStockIndexesDto';

@Injectable({
  providedIn: 'root'
})
export class CompanyStockIndexesService {
  private apiUrl = `${environment.apiUrl}/companies`;

  constructor(private http: HttpClient) {}

  get(companyId: string, year?: number): Observable<CompanyStockIndexesDto> {
    let params = new HttpParams();
    if (year !== undefined) {
      params = params.set('year', year.toString());
    }
    return this.http.get<CompanyStockIndexesDto>(`${this.apiUrl}/${companyId}/stock-indexes`, { params });
  }

  upsert(companyId: string, request: UpsertCompanyStockIndexesRequest): Observable<CompanyStockIndexesDto> {
    return this.http.put<CompanyStockIndexesDto>(`${this.apiUrl}/${companyId}/stock-indexes`, request);
  }

  delete(companyId: string, year?: number): Observable<void> {
    let params = new HttpParams();
    if (year !== undefined) {
      params = params.set('year', year.toString());
    }
    return this.http.delete<void>(`${this.apiUrl}/${companyId}/stock-indexes`, { params });
  }
}
